import React from 'react'
import MainTemplate from 'components/templates/MainTemplate'
import CategoryRoomList from 'components/organisms/CategoryRoomList'
import TopicList from 'components/organisms/TopicList'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { accountSignUpUrl } from 'frontend_core/dist/helpers/url'
import Path from 'routes/path'

export default props => (
  <MainTemplate
    title={props.title}
    description={props.description}
    image={imagePath('www/common/ogimage.png')}
    linkCanonical={props.linkCanonical}
    linkPrev={props.linkPrev}
    linkNext={props.linkNext}
    location={props.location}
    config={props.config}
    bodyClassName="body-home__index"
    data={props.data}
    {...props}
  >
    <div className="site-main">
      <div className="top-mv">
        <p className="service-logo">
          <img
            src={imagePath('www/common/logo.svg')}
            alt={i18n.t('page.home.name')}
          />
        </p>
        <h1 className="top-information__sub">
          {props.totalCount}
          件のレンタルスペースから <br className="pc-hide__sm-show" />
          目的に合ったスペースをかんたん予約
        </h1>
        <div className="page__information">
          <div className="top-menu__container">
            <div className="container">
              <ul className="row">
                {props.mainEventTypes.map((eventType, index) => {
                  const category = eventType.name
                  const nameText = i18n.t(`eventType.${category}`)
                  const url =
                    category === 'stay'
                      ? `https://stay.spacemarket.com/search`
                      : `/search?event_type=${category}&with_recommend=${true}`
                  return (
                    <li key={category} className="top-menu__list col-xs-4">
                      <a
                        href={url}
                        className="top-menu__list-button mdc-elevation--z2"
                      >
                        <img
                          src={imagePath(`www/icon/${category}_blue.svg`)}
                          alt={nameText}
                          className="top-menu__list-button-img"
                        />
                        <span className="top-menu__list-button-text">
                          {nameText}
                          <span className="top-menu__list-button-num">
                            {eventType.roomsCount}件
                          </span>
                        </span>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div className="container">
              <ul className="row">
                {props.subEventTypes.map((eventType, index) => {
                  const category = eventType.name
                  const nameText = i18n.t(`eventType.${category}`)
                  if (category == 'other') {
                    return (
                      <li
                        key={category}
                        className="top-menu__list top-menu__list-second col-xs-3"
                      >
                        <a
                          href={`/search?event_type=${category}`}
                          className="top-menu__list-button mdc-elevation--z2"
                        >
                          <img
                            src={imagePath(`www/icon/${category}_blue.svg`)}
                            alt=""
                            className="top-menu__list-button-img"
                          />
                          <span className="top-menu__list-button-text">
                            {nameText}
                          </span>
                        </a>
                        <select
                          name="others"
                          className="w100pa js-select__transparent"
                          onChange={props.eventTypeOtherDidSelect}
                        >
                          <option key="none" value="">
                            {i18n.t('page.home.label_000047')}
                          </option>
                          {props.otherEventTypes.map((eventType, index) => {
                            const category = eventType.name
                            const nameText = i18n.t(`eventType.${category}`)
                            return (
                              <option key={category} value={category}>
                                {nameText}
                              </option>
                            )
                          })}
                        </select>
                      </li>
                    )
                  } else {
                    return (
                      <li
                        key={category}
                        className="top-menu__list top-menu__list-second col-xs-3"
                      >
                        <a
                          href={`/search?event_type=${category}&with_recommend=${true}`}
                          className="top-menu__list-button mdc-elevation--z2"
                        >
                          <img
                            src={imagePath(`www/icon/${category}_blue.svg`)}
                            alt=""
                            className="top-menu__list-button-img"
                          />
                          <span className="top-menu__list-button-text">
                            {nameText}
                            <span className="top-menu__list-button-num">
                              {eventType.roomsCount}件
                            </span>
                          </span>
                        </a>
                      </li>
                    )
                  }
                })}
              </ul>
            </div>
          </div>
          <div className="top-menu__other-search">
            <h3 className="top-menu__other-ttl">カテゴリーから探す</h3>
            <ul className="top-flow__list">
              <li>
                <a href={`/areas`}>エリア</a>
              </li>
              <li>
                <a href={`/capacities`}>人数</a>
              </li>
              <li>
                <a href={`/space_types`}>会場タイプ</a>
              </li>
              <li>
                <a href={`/amenities`}>アメニティ</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {!!props.favorites &&
        props.favorites.length > 0 && (
          <CategoryRoomList
            title={'お気に入り'}
            moreLink={`dashboard`}
            footerLinkTitle={`お気に入りスペースをすべて見る`}
            rooms={props.favorites}
          />
        )}

      <div className="page__stripes top-page__padding">
        <div className="container top-container">
          <div className="top-title__container clearfix">
            <h2 className="top-title">おすすめスペースまとめ</h2>
            <a
              href={`/features`}
              className="pc-hide__sm-show top-more__area-link"
            >
              もっと見る
            </a>
          </div>
          <div className="top-units__container">
            <div className="row">
              {props.staffFeatures.map((feature, index) => {
                return (
                  <div key={feature.id} className="col-xs-3 md-matome-list">
                    <a href={`/features/${feature.uid}`}>
                      <div className="md-top-units mdc-elevation--z2">
                        <div className="md-matome-image">
                          <img
                            src={feature.image.replace('large_slide', 'square')}
                            alt={feature.title}
                            className="md-matome-image__pict"
                          />
                        </div>
                        <h3 className="md-matome-subtitle">{feature.title}</h3>
                      </div>
                    </a>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="sm-hide top-more__area">
            <a href={'/features'} className="top-more__area-link">
              スペースまとめをもっと見る
            </a>
          </div>
        </div>
      </div>

      {props.topics !== undefined &&
      props.topics !== null &&
      props.topics.length > 0 ? (
        <div className="page__stripes top-page__padding">
          <TopicList topics={props.topics} />
        </div>
      ) : null}

      <div className="page__stripes">
        <div className="top-regist">
          <div className="top-more__area top-regist__container">
            <div className="top-regist__inner">
              <div className="top-regist__unit">
                <p className="top-regist__title-guide">
                  新規アカウント登録して頂いた方全員に
                </p>
                <p className="top-regist__everyone">
                  <span>もれなく</span>
                </p>
                <h2 className="top-regist__title">
                  ¥<span className="top-regist__title-large">1,000</span>
                  <span className="top-regist__title-small">
                    相当のポイントをプレゼント！
                  </span>
                </h2>
              </div>
              <div className="top-regist__all-space">
                全てのスペースにご利用可能です
              </div>
              <div className="top-regist__text">
                <span className="top-regist__slash">
                  おトクにスペースを借りてみよう！
                </span>
              </div>
            </div>
            <div className="top-regist__button_wrap">
              <a
                href={accountSignUpUrl(props.config)}
                className="button-blue top-regist__button"
              >
                新規アカウント登録はこちら
              </a>
            </div>
          </div>
        </div>
      </div>

      {props.mainEventTypes.map(
        (eventType, index) =>
          eventType.name !== 'other' && (
            <CategoryRoomList
              key={eventType.name}
              eventTypeName={eventType.name}
              rooms={props.categoryRooms[eventType.name]}
              title={eventType.nameText}
              footerLinkTitle={`${
                eventType.nameText
              }で利用できるスペースをすべて見る`}
              moreLink={
                eventType.name === 'stay'
                  ? Path.staySearch()
                  : Path.searchCategory(eventType.name)
              }
            />
          ),
      )}

      <div className="top-static__banner">
        <div className="container">
          <h3 className="top-static__banner-title">
            あなたもホストになってみませんか
          </h3>
          <p className="top-static__banner-text">
            お持ちのスペースを今すぐ有効活用。あらゆるスペースが登録可能です。
          </p>
          <a
            href="/pages/host_entry"
            className="button-blue top-static__banner-button"
          >
            {i18n.t('page.home.label_000008')}
          </a>
        </div>
      </div>

      {props.subEventTypes.map(
        (eventType, index) =>
          eventType.name !== 'other' && (
            <CategoryRoomList
              key={eventType.name}
              rooms={props.categoryRooms[eventType.name]}
              title={eventType.nameText}
              footerLinkTitle={`${
                eventType.nameText
              }で利用できるスペースをすべて見る`}
              moreLink={`/search?event_type=${eventType.name}`}
            />
          ),
      )}

      <div className="top-static__banner top-corp-concierge__banner">
        <div className="container">
          <h3 className="top-static__banner-title">
            法人でスペースをお探しの方へ
          </h3>
          <p className="top-static__banner-text">
            便利な請求書後払いにも対応。
          </p>
          <a
            href="https://beyond.spacemarket.com/know-how/enterprise-use/?utm_source=center_banner&utm_medium=referral&utm_campaign=business_lp"
            className="button-blue top-static__banner-button"
            target="_blank"
          >
            利用方法を確認
          </a>
        </div>
      </div>

      {props.otherEventTypes.map(
        (eventType, index) =>
          eventType.name !== 'other' && (
            <CategoryRoomList
              key={eventType.name}
              rooms={props.categoryRooms[eventType.name]}
              title={eventType.nameText}
              footerLinkTitle={`${
                eventType.nameText
              }で利用できるスペースをすべて見る`}
              moreLink={`/search?event_type=${eventType.name}`}
            />
          ),
      )}

      <div className="mod-banner mod-banner__guest">
        <div className="container">
          <h3>{i18n.t('page.home.label_000059')}</h3>
          <p>{i18n.t('page.home.label_000061')}</p>
          <a
            href={accountSignUpUrl(props.config)}
            className="mod-banner__button"
          >
            {i18n.t('page.home.label_000060')}
          </a>
        </div>
      </div>
    </div>
  </MainTemplate>
)



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/index.js